export default "__VITE_ASSET__Dk7nPhaN__"